import { ReactComponent as Menu } from '../images/menu.svg';
import { ReactComponent as Settings } from '../images/settings.svg';
import { ReactComponent as Statistics } from '../images/statistics.svg';

type Props = {
    isDark: boolean,
    setScheme: (scheme: 'dark' | 'light') => void,
    setShowMenu: React.Dispatch<React.SetStateAction<boolean>>,
    setShowSettings: React.Dispatch<React.SetStateAction<boolean>>,
    setShowStatistics: React.Dispatch<React.SetStateAction<boolean>>,
    showMenu: boolean,
    showSettings: boolean,
    showStatistics: boolean
};

const Header = ({ isDark, setScheme, setShowMenu, setShowSettings, setShowStatistics, showMenu, showSettings, showStatistics }: Props): JSX.Element => {
    return (
        <header>
            <div id="toggle-menu" onClick={() => setShowMenu(!showMenu)}><Menu /></div>
            <div id="toggle-settings" onClick={() => setShowSettings(!showSettings)}><Settings /></div>
            <div id="main-title">Mosaic</div>
            <div id="toggle-statistics" onClick={() => setShowStatistics(!showStatistics)}><Statistics /></div>
            {isDark && <div id="toggle-scheme" onClick={() => setScheme('light')}><span>🔆</span></div>}
            {!isDark && <div id="toggle-scheme" onClick={() => setScheme('dark')}><span>🌙</span></div>}
        </header>
    );
}

export default Header;
